import { apiRequest } from "../util/apiUtils";

export const enquiryList = async (params) => {
  try {
    const res = await apiRequest("get", `enquiry/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const enquiryDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `enquiry/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
